import React, { useState } from "react";
import styles from '../CustomDomainModal.module.css'
import CTAButton from 'components/CTAButton/CTAButton'
import { CONN_PATH } from '../constants/strings'


const GetDomain = ({ formik, onNext, onPrevious }) => {
    return (
      <>
        <div className={styles.subHeading}>
          <div className={styles.title}>{CONN_PATH.PURCHASE_TITLE}</div>
          <div className={styles.subTitle}>{CONN_PATH.PURCHASE_DESC}</div>
          <div className={styles.goDaddyInput}>
            <input
              className={styles.input}
              placeholder="e.g. mywebsite.com"
              type="text"
              {...formik.getFieldProps(`dnsAddress.domain`)}
            />
            <CTAButton
              label="Search on Namecheap"
              onClick={() =>
                window.open(
                  `https://www.namecheap.com/domains/registration/results/?domain=${formik.values.dnsAddress.domain}`
                )
              }
              size="small"
              disabled={!formik.values.dnsAddress.domain}
              className={styles.domainSearch}
            />
          </div>
  
          <div className={styles.subTitle}>{CONN_PATH.PURCHASE_DESC_2}</div>
        </div>
        <div className={styles.btnContainer}>
          <CTAButton
            label="Back"
            onClick={onPrevious}
            size="small"
            className={styles.backButton}
            showLeftArrow={true}
            showArrow={false}
            leftArrowClass={styles.backArrow}
          />
          <CTAButton label="I’ve purchased my domain" onClick={onNext} size="small" className={styles.forwardButton} />
        </div>
      </>
    )
  }

export default GetDomain